import {t} from '@lingui/macro';

export const Type = {
    sale_quote: 'sale_quote',
    sale_order: 'sale_order',
    sale_delivery_order: 'sale_delivery_order',
    sale_invoice: 'sale_invoice',
    sale_invoice_cash: 'sale_invoice_cash',
    opening_invoice: 'opening_invoice',
    sale_delivery_note: 'sale_delivery_note',
    delivery_note: 'delivery_note',
    sale_credit_note: 'sale_credit_note',
    opening_sale_credit_note: 'opening_sale_credit_note',
    sale_payment: 'sale_payment',
    sale_refund: 'sale_refund',
    purchase_order: 'purchase_order',
    purchase_goods_received_note: 'purchase_goods_received_note',
    purchase_bill: 'purchase_bill',
    purchase_bill_cash: 'purchase_bill_cash',
    purchase_bill_claim: 'purchase_bill_claim',
    opening_bill: 'opening_bill',
    purchase_credit_note: 'purchase_credit_note',
    opening_purchase_credit_note: 'opening_purchase_credit_note',
    purchase_payment: 'purchase_payment',
    purchase_refund: 'purchase_refund',
    bank_income: 'bank_income',
    bank_expense: 'bank_expense',
    bank_transfer: 'bank_transfer',
    bank_adjustment: 'bank_adjustment',
    journal_entry: 'journal_entry',
    contra: 'contra',
    stock_adjustment: 'stock_adjustment',
    stock_transfer: 'stock_transfer',
    stock_value: 'stock_value',
    sales: 'sales',
    purchases: 'purchases',
    banking: 'banking',
    sale_debit_all: 'sale_debit_all',
    tax_deemed_payment: 'tax_deemed_payment',
    sale_credit_all: 'sale_credit_all', // used in batch sale refunds

    report_transaction_list: 'report_transaction_list',

    // Used by Number Formats:
    official_receipt: 'official_receipt',
    payment_voucher: 'payment_voucher',
    fixed_asset: 'asset',
    store_order: 'store_order',

    // Used in TransactionLink
    // purchase_expense: 'purchase_expense',
    // purchase_claim: 'purchase_claim',
    purchase_debit_all: 'purchase_debit_all',

    null: null,
    // Assets
    asset_depreciation: 'asset_depreciation',
    asset_disposal: 'asset_disposal',

    // Other
    opening_balance: 'opening_balance',
    opening: 'opening',

    statement: 'statement',
    opening_stock_adjustment: 'opening_stock_adjustment',

    minipos_order: 'minipos_order',
};

export function getParentType(transactionType) {
    switch (transactionType) {
        case Type.sale_quote:
        case Type.sale_order:
        case Type.sale_delivery_order:
        case Type.sale_invoice:
        case Type.opening_invoice:
        case Type.sale_credit_note:
        case Type.opening_sale_credit_note:
        case Type.sale_payment:
        case Type.sale_refund:
            return Type.sales;
        case Type.purchase_order:
        case Type.purchase_goods_received_note:
        case Type.purchase_bill:
        case Type.opening_bill:
        case Type.purchase_credit_note:
        case Type.opening_purchase_credit_note:
        case Type.purchase_payment:
        case Type.purchase_refund:
            return Type.purchases;
        case Type.bank_income:
        case Type.bank_expense:
        case Type.bank_transfer:
            return Type.banking;
        case Type.journal_entry:
            return Type.journal_entry;
        default:
            throw new Error(t`Invalid parent type: ${transactionType}`);
    }
}

export function getOutstandingUrl(transactionType) {
    switch (transactionType) {
        case Type.sale_credit_note:
        case Type.sale_payment:
            return '/sales/outstandings/debits';
        case Type.sale_refund:
            return '/sales/outstandings/credits';
        case Type.purchase_credit_note:
        case Type.purchase_payment:
            return '/purchases/outstandings/debits';
        case Type.purchase_refund:
            return '/purchases/outstandings/credits';
        case Type.sale_debit_all:
            return '/sales/outstandings/debits/all';
        case Type.purchase_debit_all:
            return '/purchases/outstandings/debits/all';
        case Type.sale_credit_all:
            return '/sales/outstandings/credits/all';
        default:
            throw new Error(t`No URL found for the transaction type: ${transactionType}`);
    }
}

export function getMsgType(transactionType) {
    switch (transactionType) {
        case Type.sale_quote:
            return t`quotation`;
        case Type.sale_order:
            return t`sales order`;
        case Type.sale_delivery_order:
            return t`delivery order`;
        case Type.sale_invoice:
            return t`invoice`;
        case Type.opening_invoice:
            return t`opening invoice`;
        case Type.sale_credit_note:
            return t`credit note`;
        case Type.opening_sale_credit_note:
            return t`opening credit note`;
        case Type.sale_payment:
            return t`sale payment`;
        case Type.sale_refund:
            return t`sale refund`;
        case Type.purchase_order:
            return t`purchase order`;
        case Type.purchase_goods_received_note:
            return t`goods received note`;
        case Type.purchase_bill:
            return t`bill`;
        case Type.opening_bill:
            return t`opening bill`;
        case Type.purchase_credit_note:
            return t`supplier credit`;
        case Type.opening_purchase_credit_note:
            return t`opening credit note`;
        case Type.purchase_payment:
            return t`purchase payment`;
        case Type.purchase_refund:
            return t`purchase refund`;
        case Type.bank_income:
            return t`money in`;
        case Type.bank_expense:
            return t`money out`;
        case Type.bank_transfer:
            return t`bank transfer`;
        case Type.journal_entry:
            return t`journal entry`;
        case Type.contra:
            return t`contra`;
        case Type.tax_deemed_payment:
            return t`deemed payment`;
        case Type.stock_adjustment:
            return t`stock adjustment`;
        case Type.stock_transfer:
            return t`stock transfer`;
        case Type.stock_value:
            return t`periodic value`;
        case Type.fixed_asset:
            return t`fixed asset`;
        case Type.official_receipt:
            return t`official receipt`;
        case Type.payment_voucher:
            return t`payment voucher`;
        case Type.sale_delivery_note:
            return t`delivery note`;

        case Type.minipos_order:
            return t`minipos order`;
        default:
            throw new Error(t`No URL found for the transaction type: ${transactionType}`);
    }
}

export function getMsgTypePluralized(transactionType) {
    switch (transactionType) {
        case Type.sale_quote:
            return t`quotations`;
        case Type.sale_order:
            return t`sales orders`;
        case Type.sale_delivery_order:
            return t`delivery orders`;
        case Type.sale_invoice:
            return t`invoices`;
        case Type.opening_invoice:
            return t`opening invoices`;
        case Type.sale_credit_note:
            return t`credit notes`;
        case Type.opening_sale_credit_note:
            return t`opening credit notes`;
        case Type.sale_payment:
            return t`sale payments`;
        case Type.sale_refund:
            return t`sale refunds`;
        case Type.purchase_order:
            return t`purchase orders`;
        case Type.purchase_goods_received_note:
            return t`goods received notes`;
        case Type.purchase_bill:
            return t`bills`;
        case Type.opening_bill:
            return t`opening bills`;
        case Type.purchase_credit_note:
            return t`supplier credits`;
        case Type.opening_purchase_credit_note:
            return t`opening credit notes`;
        case Type.purchase_payment:
            return t`purchase payments`;
        case Type.purchase_refund:
            return t`purchase refunds`;
        case Type.bank_income:
            return t`money in`;
        case Type.bank_expense:
            return t`money out`;
        case Type.bank_transfer:
            return t`fund transfers`;
        case Type.journal_entry:
            return t`journal entries`;
        case Type.contra:
            return t`contras`;
        case Type.tax_deemed_payment:
            return t`deemed payments`;
        case Type.stock_adjustment:
            return t`stock adjustments`;
        case Type.stock_transfer:
            return t`stock transfers`;
        case Type.stock_value:
            return t`periodic values`;
        case Type.fixed_asset:
            return t`fixed assets`;
        case Type.official_receipt:
            return t`official receipts`;
        case Type.payment_voucher:
            return t`payment vouchers`;
        case Type.sale_delivery_note:
            return t`delivery notes`;
        case Type.minipos_order:
            return t`minipos orders`;
        default:
            throw new Error(t`No URL found for the transaction type: ${transactionType}`);
    }
}

export function capitalize(text) {
    const separateWord = text.toLowerCase().split(' ');
    for (let i = 0; i < separateWord.length; i += 1) {
        separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
            separateWord[i].substring(1);
    }
    return separateWord.join(' ');
}

export function getMsgTypeCapitalized(transactionType) {
    const text = getMsgType(transactionType);
    return capitalize(text);
}

export function getStatus(status) {
    switch (status) {
        case 'pending_approval':
            return "pending approval";
        default:
            return status;
    }
}

export function hasContactField(transactionType) {
    switch (transactionType) {
        case Type.sale_quote:
        case Type.sale_order:
        case Type.sale_delivery_order:
        case Type.sale_invoice:
        case Type.sale_invoice_cash:
        case Type.sale_credit_note:
        case Type.sale_payment:
        case Type.sale_refund:
        case Type.purchase_order:
        case Type.purchase_goods_received_note:
        case Type.purchase_bill:
        case Type.purchase_bill_cash:
        case Type.purchase_bill_claim:
        case Type.purchase_credit_note:
        case Type.purchase_payment:
        case Type.purchase_refund:
        case Type.contra:
            return 'required';
        // in company settings
        case Type.official_receipt:
        case Type.payment_voucher:
        case Type.sale_delivery_note:
            return 'required';
        case Type.bank_income:
        case Type.bank_expense:
        case Type.journal_entry:
            return 'optional';
        case Type.bank_transfer:
        case Type.stock_adjustment:
        case Type.stock_transfer:
        case Type.tax_deemed_payment:
        default:
            return false;
    }
}
